import React, { Component, Fragment } from 'react';
import IframeComm from 'react-iframe-comm';

import ReactGA from 'react-ga';

import Paragraph from '../../collections/Paragraph/Paragraph';

import SessionStorage from '../../storage/SessionStorage/SessionStorage';

class EComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            step: 1,
            iframeHeight: 200,
            ecompState: '',
            hideFrame: false,
        }
        
        this.updateSessionData = this.updateSessionData.bind(this);
        this.onReceiveMessage = this.onReceiveMessage.bind(this);
    };

    componentDidMount() {
        ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID);
        this.props.update({loading: true});
        this.props.handleFormPrompt(true);
        
    }

    updateSessionData(event) {
        SessionStorage.setSessionStorageItem('bal', '4061ddbfe486cce727972d8abc85171005b2911c3fb21aabd2481bab12fdba1b');
        this.props.update({
            loading: true, 
            accessBalance: '4061ddbfe486cce727972d8abc85171005b2911c3fb21aabd2481bab12fdba1b'
        });
        this.props.handleErrorMessage(false, '');
        this.props.handleFormPrompt(false);    

        this.props.api.getSessionData(this.props.appState.session.SessionDataId)
          .then(response => {
              let sessionData = response;
              sessionData.CardActivationStatusId = 3;
              this.props.update({
                  session: sessionData
              }, (state) => {

                  let username = ''
                  if (state.cardDetails.FirstName !== null && state.cardDetails.FirstName !== undefined && state.cardDetails.FirstName.length > 0) {
                      username = state.cardDetails.FirstName;
                  } else if (state.cardDetails.Title !== null && state.cardDetails.Title !== undefined && state.cardDetails.Title.length > 0) {
                      username = `${state.cardDetails.Title} ${state.cardDetails.LastName}`;
                  } else {
                      username = state.cardDetails.LastName;
                  }

                  let data = {};
                  data.CardSerialNumber = state.session.CardSerialNumber;
                  data.TemplateCode = state.settings.emailTemplate;
                  data.Payload = JSON.parse(state.settings.emailPayload);
                  data.Payload.toAddress = [state.session.UserEmail];
                  data.Payload.name = username;
                  data.Payload.firstName = state.cardDetails.FirstName;
                  data.Payload.lastName = state.cardDetails.LastName;
                  data.Payload.communicationCode = state.cardDetails.CardTypeCode;
                  data.Payload.MobileNumber = state.session.MobileNumber;
                  data.Payload.balance = state.session.CardBalance;
                  data.Payload.subscribed = state.session.CommunicationSubscriptions === null ? false : true;
                  // data.Payload.termsLink = state.settings.terms;
                  data.Payload.termsLink =  `${this.props.url === '/' ? window.location.origin + this.props.url +'terms' : window.location.origin + this.props.url + '/terms'}`;


                  // console.log('payload data', data);

                  this.props.api.postSessionData(state.session)
                    .then(response => {

                        this.props.api.postCardActivationConfirmationEmail(data)
                          .then(response => {
                              this.props.update({loading: false});
                              this.props.history.push(this.props.generateURIFromCode(this.props.appState.code, 'balance'))
                          })
                          .catch(error => {
                              // this.props.handleErrorMessage(true, 'Error: postCardActivationConfirmationEmail failed');
                              this.props.update({loading: false});
                              this.props.history.push(this.props.generateURIFromCode(this.props.appState.code, 'balance'))
                          })
                
                    })
                    .catch(error => {
                        this.props.handleErrorMessage(true, 'Error: postSessionData failed');
                        this.props.update({loading: false});
                    });
              });
          })
          .catch(error => {
              this.props.handleErrorMessage(true, 'Error: getSessionData failed');
              this.props.update({loading: false});
          })
    }

    onReady = () => {
        this.props.update({loading: false});
    }

        onReceiveMessage = (message) => {
            switch (message.data) {
                case 'AUTHENTICATION':
                    this.sendEvent('CardActivation', 'Journey', 'CardActivationUserCredentials');
                    this.setState({iframeHeight: 300, ecompState: '', hideFrame: false}, () => {
                    })
                    break;
                case 'CARD_ACTIVATION':
                    this.setState({iframeHeight: 220, ecompState: ''})
                    break;
                case 'SECOND_SECURITY_FACTOR':
                    this.sendEvent('CardActivation', 'Journey', 'CardActivationCVC');
                    this.setState({iframeHeight: 300, ecompState: ''})
                    break;
                case 'DISPLAY_PIN':
                    this.sendEvent('CardActivation', 'Journey', 'CardActivationPINReveal');
                    this.setState({iframeHeight: 300, ecompState: 'DISPLAY_PIN'}, () => {
                        SessionStorage.setSessionStorageItem('Activate', 1)
                        if (SessionStorage.getSessionStorageItem('DISPLAY_PIN') === null || SessionStorage.getSessionStorageItem('DISPLAY_PIN') === undefined) {
                            SessionStorage.setSessionStorageItem('DISPLAY_PIN', 'DISPLAY_PIN')
                            this.sendEvent('CardActivation', 'Process', 'ActivationDisplayPin')
                        } else {
                            SessionStorage.setSessionStorageItem('DISPLAY_PIN', 'DISPLAY_PIN > 1')
                            this.sendEvent('CardActivation', 'Process', 'ActivationPinAgain')
                        }
                    })
                    break;
                case 'FINAL_STEP': 
                    // console.log('Event received: CardActivationPage - FINAL_STEP');
                    this.sendEvent('CardActivation', 'Journey', 'CardActivationExitMessage');
                    this.setState({iframeHeight: 200, ecompState: '', hideFrame: true})

                    this.props.update({
                        loading: false
                    }, () => {
                        if(this.props.appState.cardDetails.MyAccountUser !== false){
                            // User already exists
                            this.updateSessionData();
                        }else{
                            // New user
                            this.props.nextHandler();
                        }
                        
                    });
                    // this.updateSessionData();
                    break;
                default:
            }
        }

        onLoadIframe = () => {
            this.setState();
        }

        sendEvent = (category, action, label) => {
            ReactGA.event({
                category: category,
                action: action,
                label: label
            })
        }

        render() {

            const attributes = {
                src: this.props.appState.eComponentURL,
                width: "100%",
                height: this.state.iframeHeight
            };

            return (
              <Fragment>
                { this.state.ecompState === 'DISPLAY_PIN' ?
                  <Paragraph center textColor={this.props.appState.ui.cardActivation.card.titleTextColor} mbottom={'2rem'}>{'Your PIN will be revealed one digit at a time and can be displayed up to three times.'}</Paragraph>
          :
            null
    }

    { this.state.hideFrame ?
        null
    :
        <IframeComm attributes={attributes} handleReady={this.onReady} handleReceiveMessage={this.onReceiveMessage} />
    }

  </Fragment>
);
    }
};

export default EComponent;


// WEBPACK FOOTER //
// ./src/containers/CardActivationPage/Step3.js